/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Content.ContainerAccessControl_
///   This is an auto-generated enumeration of the SWFC_Learning.Content.ContainerAccessControl domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum ContainerAccessControl_ {
   /// <summary>
   ///   Unlocked (Unlock)
   /// </summary>
   Unlocked = 0,
   /// <summary>
   ///   Locked (Lock)
   /// </summary>
   Locked = 1,
   /// <summary>
   ///   Hidden (Hidden)
   /// </summary>
   Hidden = 2
}

export const ContainerAccessControls: ContainerAccessControl[] = [
   {
      code: ContainerAccessControl_.Unlocked,
      literal: 'Unlocked',
      description: 'Unlocked',
      shortDescription: 'Unlock',
      listPriority: 0,

      name: 'Unlocked',

      typeName: "ContainerAccessControl"
   },
   {
      code: ContainerAccessControl_.Locked,
      literal: 'Locked',
      description: 'Locked',
      shortDescription: 'Lock',
      listPriority: 0,

      name: 'Locked',

      typeName: "ContainerAccessControl"
   },
   {
      code: ContainerAccessControl_.Hidden,
      literal: 'Hidden',
      description: 'Hidden',
      shortDescription: 'Hidden',
      listPriority: 0,

      name: 'Hidden',

      typeName: "ContainerAccessControl"
   }
]

export class ContainerAccessControl implements IDomainModel {
   code: ContainerAccessControl_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   name: string

   typeName: string

   static toDomainModel(code: ContainerAccessControl_): ContainerAccessControl {
      return ContainerAccessControls.find(d => d.code === code)
   }
}
